import React, { useEffect, useRef } from 'react';
import { Check, Sparkles } from 'lucide-react';

const ProcessingAnimation = ({ isLoading, onComplete }) => {
  const wasLoading = useRef(false);

  useEffect(() => {
    if (wasLoading.current && !isLoading) onComplete?.();
    wasLoading.current = isLoading;
  }, [isLoading, onComplete]);

  useEffect(() => {
    if (!isLoading) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previousOverflow; };
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <div className="ap-processing-layer" role="status" aria-live="polite" aria-label="Reviewing your submission">
      <section className="ap-processing-dialog">
        <header>
          <span><Sparkles size={18} /> Aurora review</span>
          <h2>Reviewing your work.</h2>
          <p>We’re reading your response and preparing focused, actionable feedback.</p>
        </header>

        <div className="ap-processing-track" aria-hidden="true"><span /></div>

        <ol className="ap-processing-stages" aria-hidden="true">
          <li className="is-complete"><Check size={14} /><span>Reading your submission</span></li>
          <li className="is-active"><i /><span>Evaluating the details</span></li>
          <li><i /><span>Preparing your feedback</span></li>
        </ol>
      </section>
    </div>
  );
};

export default ProcessingAnimation;
